import React from "react";
import Starfield from "../components/Starfield";
import About from "../components/pages/About/About";
import Skills from "../components/pages/Skills/Skills";
import Projects from "../components/pages/Projects/Projects";
import Contact from "../components/pages/Contact/Contact";

const Layout = () => {
  return (
    <>
      <Starfield />
      {/* <Navigation /> */}
      <div className="w-full flex flex-col items-center m-[0 auto]">
        <div
          id="startSection"
          className="w-full md:max-w-[100rem] h-fit flex flex-col px-8 md:px-26 lg:px-52 pt-10 justify-center md:justify-start items-center md:items-start text-center md:text-left"
        >
          <div className="flex flex-col rounded-3xl w-fit mt-12 md:mt-20">
            <span className="h-fit lg:my-3 text-3xl lg:text-5xl font-light">
              hello! i am
            </span>
            <span className="h-fit md:py-3 text-4xl lg:text-7xl text-transparent font-bold bg-clip-text bg-gradient-to-r from-backgroundLight to-primary">
              laura gomes,
            </span>
            <span className="h-fit lg:my-3 text-3xl lg:text-7xl ">
              a web developer.
            </span>
          </div>
          <div className="w-full md:w-3/4 z-20">
            <p className="font-thin text-sm md:text-lg my-5">
              I am a web developer who enjoys the whole process of web
              development. From the initial{" "}
              <strong className="font-bold text-primary"> design</strong>, to{" "}
              <strong className="font-bold text-primary">
                {" "}
                implementation
              </strong>
              , and, of course, quality assurance with thorough{" "}
              <strong className="font-bold text-primary">
                {" "}
                testing concepts{" "}
              </strong>{" "}
              to finally bring your project to life.
            </p>
            <p className="font-thin text-sm md:text-lg my-5">
              Building{" "}
              <strong className="font-bold text-primary">
                {" "}
                user-friendly, responsive
              </strong>
              , and
              <strong className="font-bold text-primary">
                {" "}
                performant{" "}
              </strong>{" "}
              websites is a priority of mine.
            </p>
          </div>

          {/* SECTION | SKILLS  */}
          <Skills />

          {/* SCROLL ANIMATION */}
          {/* <div
            onClick={() => handleScroll("aboutMeSection")}
            className="flex flex-col items-center mt-20"
          >
            <span className="md:block border-b-2 border-r-2 animate-mouse-scroll  snap-end [animation-delay:0.1s] border-font-textBody hidden md:w-4 md:h-4 rotate-45 delay-100 alternate" />
            <span className="md:block border-b-2 border-r-2 animate-mouse-scroll snap-end [animation-delay:0.3s] border-font-textBody hidden md:w-4 md:h-4 rotate-45 -m-1" />
          </div> */}
        </div>

        {/* SECTION | ABOUT ME  */}
        <div className="my-16  px-8 md:px-16 text-center lg:text-right flex flex-col justify-center items-center max-w-[80rem] m-[0 auto]">
          <div className="flex items-center">
            <div className="hidden lg:block h-fit">
              {/* PLACEHOLDER GRAPHIC */}
              <img src="images/laptop.png" alt="graphic" className="h-1/2" />
            </div>
            <div className="w-full lg:w-2/3 h-fit ">
              <About />
            </div>
          </div>
          {/* <Experiences /> */}
        </div>
      </div>

      {/* SECTION | PROJECTS  */}
      <Projects />
      {/* SECTION | CONTACT  */}
      <div className="h-full px-8 md:px-24 lg:px-72 text-left flex justify-center items-center w-full py-20">
        <Contact />
      </div>
    </>
  );
};

export default Layout;
